import { render } from "./fenlei.vue?vue&type=template&id=79f8ccea&scoped=true"
import script from "./fenlei.vue?vue&type=script&lang=js"
export * from "./fenlei.vue?vue&type=script&lang=js"

import "./fenlei.vue?vue&type=style&index=0&id=79f8ccea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f8ccea"]])

export default __exports__